import React from 'react';
import { GAME_DETAILS_QUERY, GameDetailsQuery } from './gamedetailsform-graphql';
import GameDetailsForm from './GameDetailsForm';
import { useQuery } from '@apollo/client';
import GraphQLLoader from '../../../../../../common/graphql/graphql-loader';

export interface Props {}

/**
 * The game info form requires the list of tags and categories, which this loadeder will fetch.
 */
const GameDetailsFormLoader: React.FC<Props> = () => {
  const { loading, error, data } = useQuery<GameDetailsQuery>(GAME_DETAILS_QUERY);
  const tags = data?.tags.filter((tag) => tag.isCore) || [];

  return (
    <GraphQLLoader loading={loading} error={error}>
      {!loading && !error && <GameDetailsForm categories={data!.categories} tags={tags} />}
    </GraphQLLoader>
  );
};

export default GameDetailsFormLoader;
